import { useCallback } from 'react';

import { V6_SLUG_MAP } from '@/constants/V6_SLUG_MAP';

export type FmBotSlugSelections = {
  gender: 'male' | 'female';
  ageGeneration?: string | null;
  hairColor?: string | null;
  bodyShape?: string | null;
};

/**
 * Hook that returns a function to resolve bot slug for FM campaign (own-ai-multigender-fm).
 * Replaces the logic previously in G34bjedMG9_19_fmSlugger.
 */
export const useFmBotSlug = () => {
  return useCallback((selections: FmBotSlugSelections): string | null => {
    if (!selections.gender) {
      return null;
    }

    if (selections.gender === 'male') {
      if (!selections.ageGeneration) {
        return null;
      }
      if (selections.ageGeneration === 'young') {
        return 'leo-93dy7e';
      }
      if (selections.ageGeneration === 'old') {
        return 'marcus-sclnwv';
      }
      return null;
    }

    if (selections.gender === 'female') {
      if (
        !selections.ageGeneration ||
        !selections.hairColor ||
        !selections.bodyShape
      ) {
        return null;
      }
      const key = `${selections.ageGeneration}_${selections.hairColor}_${selections.bodyShape}`;
      return key in V6_SLUG_MAP ? V6_SLUG_MAP[key] : null;
    }

    return null;
  }, []);
};
